/**
 * Returns the hash containing the codes and countries as key/value pairs.
 */
export default function() {
  return { 
    CA: 'Canada',
    GB: 'United Kingdom',
    US: 'United States',
  };
}
